export default {
  studyMap_accumulated_class: 'Cumulative credit hours',
  studyMap_grantee: 'Grantee',
  studyMap_relearning: 'Re-learning',
  studyMap_show_certificate: '1105Web-Display certificate of completion',
  studyMap_check_learn_map0406: '0406Web-View learning map',
  studyMap_show_learn_map0405: '0405Web-Display my learning map list',
  studyMap_check_top: 'View ranking',
  studyMap_continue_customs: 'Continue',
  studyMap_show_level_rank: '1104Web-Display level ranking',
  studyMap_go_task_finished: 'You have started the learning task. Have you completed?' ,
  studyMap_resource_invalid: 'The resource is invalid',
  studyMap_accompany_training_task: 'Number of tasks of training',
  studyMap_switch_task_level: '1102Web-Toggle task levels',
  studyMap_check_task_top: '1103Web-View level ranking',
  studyMap_current_level: 'Level {TabEnum[i]}',
  studyMap_show_learn_map1101: '1101Web-Display learning map details',
  studyMap_one: '1',
  studyMap_two: '2',
  studyMap_three: '3',
  studyMap_four: '4',
  studyMap_five: '5',
  studyMap_six: '6',
  studyMap_seven: '7',
  studyMap_eigth: '8',
  studyMap_nine: '9',
  studyMap_ten: '10',
  studyMap_eleven: 'Eleven',
  studyMap_twelve: 'Twelve',
  studyMap_thirteen: 'Thirteen',
  studyMap_fourteen: 'Fourteen',
  studyMap_fifteen: 'Fifteen',
  studyMap_ID_cannot_empty: "The phase learning project id cannot be empty!" ,
  studyMap_learn_invalid: 'Phase learning program has expired!',
  studyMap_without_right: 'You have no permission!'
}
